var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');
var resolve = require('./resolve');

exports.GetApplicantLegalStatusTypes = function () {
  return request.get(resolve(config.url(), '/applicantOrgStatusTypes')).promise();
}
